import { createReducer, on } from '@ngrx/store';

import { CalendarTypeModel } from '@components/report-filters/filters/calendars-filter/models/calendarTypeModel';
import {
    add_destinations,
    add_employees,
    add_job_categories,
    reset_filters,
    set_business_date_and_calendars,
    set_business_rule_group,
    set_combined_select_filters,
    set_date_for_multi_picker,
    set_date_for_single_picker,
    set_date_type_to_custom,
    set_selected_date,
    set_selected_view,
    set_standalone_report_filters,
} from '@rpt-ngrx/actions/filters.action';
import { IFilterState } from '@shared/types/filters';
import { DateTypeModel } from '@xenial-ux/xux-datepicker/types/dateTypeModel';

const initialState: IFilterState = {
    job_categories: [],
    destinations: [],
    business_rule_groups: null,
    businessDate: null,
    calendars: [],
    employees: [],
    multipleBusinessDate: null,
    selectedDateForSingleDate: null,
    selectedDateForMultiDate: null,
    singleBusinessDate: null,
    selectedView: null,
    standaloneReportFilters: {},
    combinedSelectFilters: {},
};

const _filtersReducer = createReducer(
    initialState,
    on(add_employees, (state, { employees }): IFilterState => ({ ...state, employees })),
    on(add_job_categories, (state, { job_categories }): IFilterState => ({ ...state, job_categories })),
    on(add_destinations, (state, { destinations }): IFilterState => ({ ...state, destinations })),
    on(
        set_business_rule_group,
        (state, { business_rule_groups }): IFilterState => ({ ...state, business_rule_groups }),
    ),
    on(
        set_selected_date,
        (state, { typeOfCalendar, selectedDate, applied }): IFilterState => ({
            ...state,
            [typeOfCalendar === CalendarTypeModel.SINGLE_DATE
                ? 'selectedDateForSingleDate'
                : 'selectedDateForMultiDate']:
                typeOfCalendar === CalendarTypeModel.SINGLE_DATE
                    ? applied
                        ? { type: 'single', value: selectedDate.value }
                        : state.selectedDateForSingleDate
                    : applied
                      ? selectedDate
                      : state.selectedDateForMultiDate,
        }),
    ),
    on(
        set_date_type_to_custom,
        (state, { selectedDate, isDrillDown }): IFilterState => ({
            ...state,
            selectedDateForMultiDate: isDrillDown
                ? state.selectedDateForMultiDate
                : { type: DateTypeModel.CUSTOM, value: selectedDate.value },
        }),
    ),
    on(
        set_date_for_single_picker,
        (state, { selectedDateForSingleDate }): IFilterState => ({ ...state, selectedDateForSingleDate }),
    ),
    on(
        set_date_for_multi_picker,
        (state, { selectedDateForMultiDate }): IFilterState => ({ ...state, selectedDateForMultiDate }),
    ),
    on(
        set_business_date_and_calendars,
        (state, { businessDate, calendars }): IFilterState => ({
            ...state,
            businessDate,
            calendars,
        }),
    ),

    on(set_selected_view, (state, { selectedView }): IFilterState => ({ ...state, selectedView })),
    on(reset_filters, (): IFilterState => initialState),
    on(
        set_standalone_report_filters,
        (state, { standaloneReportFilters }): IFilterState => ({ ...state, standaloneReportFilters }),
    ),
    on(
        set_combined_select_filters,
        (state, { combinedSelectFilters }): IFilterState => ({ ...state, combinedSelectFilters }),
    ),
);

export function filtersReducer(state, action) {
    return _filtersReducer(state, action);
}
